import { render, staticRenderFns } from "./NoticeNumber.vue?vue&type=template&id=e6e4cca0&scoped=true&"
import script from "./NoticeNumber.vue?vue&type=script&lang=js&"
export * from "./NoticeNumber.vue?vue&type=script&lang=js&"
import style0 from "./NoticeNumber.vue?vue&type=style&index=0&id=e6e4cca0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e4cca0",
  null
  
)

export default component.exports